<template>
  <div>
    <PayPalCasesHead
        :showFilter="showFilter"
        :countFilterParams="countFilterParams"
        @toggleFilter="toggleFilter"
        @filter="$emit('filter')"
        @changeFilter="changeFilter"
        @selectAll="selectAll"
    />

    <div class="table-filter-wrap">

      <PayPalCasesFilter
          :showFilter="showFilter"
          :filterGetParams="filterGetParams"
          :countFilterParams="countFilterParams"
          @close="closeFilter"
          @changeFilter="changeFilter"
          @resetFilter="$emit('resetFilter')"
      />

      <PayPalCasesTable
          :countFilterParams="countFilterParams"
          :selectedNow="selectedNow"
          @showMore="$emit('showMore')"
          @resetFilter="$emit('resetFilter')"
          @downloadFiles="type => $emit('downloadFiles', type)"
      />
    </div>
  </div>
</template>

<script>


  import PayPalCasesHead from "./PayPalCasesHead/PayPalCasesHead";
  import PayPalCasesTable from "./PayPalCasesTable/PayPalCasesTable";
  import PayPalCasesFilter from "./PayPalCasesFilter/PayPalCasesFilter";

  export default {
    name: "PayPalCasesTableUser",

    components: {
      PayPalCasesHead,
      PayPalCasesTable,
      PayPalCasesFilter,
    },

    props: {
      countFilterParams: Number,
      filterGetParams: Object,
    },

    data(){
      return{
        showFilter: false,
        filterId: '',
        filterName: '',

        selectedNow: false,
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },

      changeShopType(index) {
        this.$emit('changeShopType', index)
      },


      changeFilter(data) {
        console.log(data);
        this.$emit('changeFilter', data)
      },

      selectAll(val) {
        this.selectedNow = val
      },
    }
  }
</script>

<style scoped>

</style>
